import { CheckOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { ScheduleReportStatus } from 'services/api';

type StatusTagConfig = {
  icon: React.ReactNode;
  color: string;
  styleKey: string;
  text: string;
  type: ScheduleReportStatus;
};

const success: StatusTagConfig = {
  icon: <CheckOutlined />,
  color: 'success',
  styleKey: 'success',
  text: 'Конфликтов нет',
  type: ScheduleReportStatus.SUCCESS,
};

const logical: StatusTagConfig = {
  icon: <ExclamationCircleOutlined />,
  color: 'magenta',
  styleKey: 'logical',
  text: 'Логические конфликты',
  type: ScheduleReportStatus.CRITICAL,
};

const sanpin: StatusTagConfig = {
  icon: <ExclamationCircleOutlined />,
  color: 'gold',
  styleKey: 'sanpin',
  text: 'Конфликты СанПиН',
  type: ScheduleReportStatus.WARNING,
};

export const STATUS_TAGS: Record<ScheduleReportStatus, StatusTagConfig[]> = {
  [ScheduleReportStatus.CRITICAL_WITH_WARNINGS]: [logical, sanpin],
  [ScheduleReportStatus.CRITICAL]: [logical],
  [ScheduleReportStatus.WARNING]: [sanpin],
  [ScheduleReportStatus.SUCCESS]: [success],
};

export const DEFAULT_TAG = [success];
